import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { cn } from "../lib/cn.js";
/**
 * Indexado por objeto, não `` `h${level}` ``: um template literal type
 * colapsa para `string` neste ponto do arquivo, e o JSX não aceita um
 * `string` genérico como nome de elemento — só um literal. A tabela dá o
 * literal exato sem precisar de `as`.
 */
const HEADING_TAG = { 2: 'h2', 3: 'h3', 4: 'h4' };
export const Section = ({ title, description, action, level = 3, children, className, }) => {
    const generatedId = useId();
    const titleId = title === undefined ? undefined : `${generatedId}-title`;
    const Heading = HEADING_TAG[level];
    return (_jsxs("section", { "aria-labelledby": titleId, 
        /*
         * A seção É um cartão — F180 (fase 4).
         *
         * Era moldura sem fundo: sobre a página cinza (fase 2) ela ficava
         * transparente, e ao lado de um `StatTile` ou de uma `TableContainer`
         * apareciam três cantos diferentes na mesma tela. Agora as três peças do
         * kit dizem a mesma coisa — fundo `--surface`, canto `--radius-lg` — e é
         * isso que faz uma tela montada com o kit parecer montada de propósito.
         */
        className: cn('flex flex-col gap-3 rounded-(--radius-lg) border border-(--border-subtle)', 'bg-(--surface) p-3', className), children: [title === undefined && description === undefined ? null : (_jsxs("div", { className: "flex items-start justify-between gap-3", children: [_jsxs("div", { className: "flex flex-col gap-0.5", children: [title === undefined ? null : (_jsx(Heading, { id: titleId, className: "text-(length:--text-section) font-(--weight-semibold) text-(--text-primary)", children: title })), description === undefined ? null : (_jsx("p", { className: "text-(length:--text-xs) text-(--text-secondary)", children: description }))] }), action] })), children] }));
};
//# sourceMappingURL=section.js.map